// Client-side fail-fast ceiling for raw-IFC preview. Parsing a raw IFC on the
// main thread (web-ifc WASM) hangs the tab well before the 4 GiB WASM wall — a
// ~1.68 GiB model never completes. Above this cap the viewer refuses to
// download/parse and surfaces a "too large to preview" state instead.
// Best-effort: only fires when the server sends a usable Content-Length. The
// real fix is the server-side .frag conversion pipeline (see the large-IFC
// design spec). Lives here (not in @apis/cad) so both the api layer and the
// presentational ViewerError can share one source of truth without the
// component importing from the api layer.
export const CAD_MAX_PREVIEW_BYTES = 200 * 1024 * 1024; // 200 MB

/** The preview cap in whole MB — single source of truth for the user-facing message. */
export const CAD_MAX_PREVIEW_MB = Math.round(CAD_MAX_PREVIEW_BYTES / 1024 / 1024);

// Hard ceiling for an uploaded IFC source file, mirroring the backend
// `CAD_UPLOAD_MAX_BYTES` default (2 GiB). Above the proven 1.68 GiB sample and
// below the ~4 GiB wasm conversion wall. The client pre-checks a picked file
// against this before starting an upload so an oversized file fails instantly
// instead of after a long transfer (the server enforces the real limit — the
// client check is a courtesy). GiB (1024-based), matching the backend constant.
export const CAD_UPLOAD_MAX_BYTES = 2 * 1024 * 1024 * 1024; // 2 GiB

/** The upload cap in whole GB — single source of truth for the user-facing message. */
export const CAD_UPLOAD_MAX_GB = Math.round(CAD_UPLOAD_MAX_BYTES / 1024 / 1024 / 1024);
